/* eslint-disable @typescript-eslint/no-explicit-any */
import type { MarketInfo, RequestInfo } from "../../models";
import { getAppContextState } from "./rootSelectors";

export const getAnonymousToken = (state: any): string | undefined =>
  getRequestInfo(state).anonToken;

export const getLocale = (state: any): string => getMarketInfo(state).locale;

export const getLocaleWithScript = (state: any): string => getMarketInfo(state).localeWithScript;

export const getMarketInfo = (state: any): MarketInfo => getAppContextState(state).marketInfo;

export const getRequestInfo = (state: any): RequestInfo => getAppContextState(state).requestInfo;

export const getRequestPath = (state: any): string => getRequestInfo(state).path;

export const isReactDomHydrating = (state: any): boolean =>
  getAppContextState(state).isReactDomHydrating;

export const getBootstrapInitializedLce = (state: any) =>
  getAppContextState(state).clientBootstrapInfo.initialized;
